import React from 'react'
import logo from '../_img/logo.png'

const Header = () => {
  return (
    <div className='bg-white border-b-[1px] md:border-b-white'>
          <img className="w-[6rem] md:w-[7.5rem] mx-auto mb-[2rem] md:mb-[1.3rem] lg:mb-0 lg:ml-[1rem] lg:translate-y-[1.2rem]" src={logo} alt="" />
          <h1 className='text-black mx-auto mt-[-3rem] mb-[-0.6rem] font-bold text-[1.5rem] md:text-[2.5rem] text-center'>Haalo Persona Inventory</h1>
          <p className='mx-auto text-center mb-[1.3rem] mt-1 font-extralight text-[0.85rem]'>Powered by Avenica<span>&reg;</span></p>
    </div>
  )
}

export default Header